import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const AuthLogin = Loadable(lazy(() => import('views/Authentication/Auth/Login')));
const AuthRegister = Loadable(lazy(() => import('views/Authentication/Auth/Register')));
const GitHubOAuth = Loadable(lazy(() => import('views/Authentication/Auth/GitHubOAuth')));
const LarkOAuth = Loadable(lazy(() => import('views/Authentication/Auth/LarkOAuth')));
const OidcOAuth = Loadable(lazy(() => import('views/Authentication/Auth/OidcOAuth')));
const ForgetPassword = Loadable(lazy(() => import('views/Authentication/Auth/ForgetPassword')));
const ResetPassword = Loadable(lazy(() => import('views/Authentication/Auth/ResetPassword')));
const Home = Loadable(lazy(() => import('views/Home')));
const About = Loadable(lazy(() => import('views/About')));
// 公开（免登录）页：模型价目 + 使用指南 —— 商业化转化链路，陌生访客可直接看
const Pricing = Loadable(lazy(() => import('views/Pricing')));
const PricingDetail = Loadable(lazy(() => import('views/Pricing/Detail')));
const PublicGuide = Loadable(lazy(() => import('views/Guide/PublicGuide')));
// 合规页（公开）：支付宝签约审核会实际访问
const UserAgreement = Loadable(lazy(() => import('views/Legal/UserAgreement')));
const PrivacyPolicy = Loadable(lazy(() => import('views/Legal/PrivacyPolicy')));
const RefundPolicy = Loadable(lazy(() => import('views/Legal/RefundPolicy')));
const NotFoundView = Loadable(lazy(() => import('views/Error')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const OtherRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '',
      element: <Home />
    },
    {
      path: '/about',
      element: <About />
    },
    {
      path: '/pricing',
      element: <Pricing />
    },
    {
      path: '/pricing/:model',
      element: <PricingDetail />
    },
    {
      path: '/guide',
      element: <PublicGuide />
    },
    {
      path: '/user-agreement',
      element: <UserAgreement />
    },
    {
      path: '/privacy-policy',
      element: <PrivacyPolicy />
    },
    {
      path: '/refund-policy',
      element: <RefundPolicy />
    },
    {
      path: '/login',
      element: <AuthLogin />
    },
    {
      path: '/register',
      element: <AuthRegister />
    },
    {
      path: '/reset',
      element: <ForgetPassword />
    },
    {
      path: '/user/reset',
      element: <ResetPassword />
    },
    {
      path: '/oauth/github',
      element: <GitHubOAuth />
    },
    {
      path: '/oauth/lark',
      element: <LarkOAuth />
    },
    {
      path: 'oauth/oidc',
      element: <OidcOAuth />
    },
    {
      path: '/404',
      element: <NotFoundView />
    }
  ]
};

export default OtherRoutes;
